import {
	TransferFundOptionContainer,
	TransferPinConfirmationContainer,
	TransferSuccessContainer,
	TransferFailedContainer,
} from '../../../containers';
import ConfirmTransfer from '../ConfirmTransfer';
import { Modal } from '../../../components';
import React from 'react';

const TransferFunds = ({
	closeTransferModal,
	transferSwitchState,
	sharedState,
	bankListContent,
	setBankListContent,
	goBack,
	beneficiaryContent,
	setBeneficiaryContent,
	stage2,
	setStage2,
	setShowSurvey,
	needFeedback,
}) => {
	return (
		<Modal closeModal={closeTransferModal} goBack={goBack}>
			{sharedState.pinContent ? (
				<TransferPinConfirmationContainer
					transferSwitchState={transferSwitchState}
				/>
			) : sharedState.confirmTransferContent ? (
				<ConfirmTransfer transferSwitchState={transferSwitchState} />
			) : sharedState.transferSuccessContent ? (
				<TransferSuccessContainer
					closeModal={closeTransferModal}
					needFeedback={needFeedback}
					setShowSurvey={setShowSurvey}
				/>
			) : sharedState.transferFailedContent ? (
				<TransferFailedContainer closeModal={closeTransferModal} />
			) : (
				<TransferFundOptionContainer
					closeTransferModal={closeTransferModal}
					transferSwitchState={transferSwitchState}
					bankListContent={bankListContent}
					setBankListContent={setBankListContent}
					beneficiaryContent={beneficiaryContent}
					setBeneficiaryContent={setBeneficiaryContent}
					stage2={stage2}
					setStage2={setStage2}
					setShowSurvey={setShowSurvey}
				/>
			)}
		</Modal>
	);
};

export default TransferFunds;
